import DeviceLoanApprovalTable from "./ApprovalTable";

const FieldOfficerDeviceLoanApproval = () => <DeviceLoanApprovalTable level="fieldOfficer" />;

export default FieldOfficerDeviceLoanApproval;
